import { render, staticRenderFns } from "./SuperadminEmployeeSyncSettings.vue?vue&type=template&id=90dba8d0&scoped=true&"
import script from "./SuperadminEmployeeSyncSettings.vue?vue&type=script&lang=js&"
export * from "./SuperadminEmployeeSyncSettings.vue?vue&type=script&lang=js&"
import style0 from "./SuperadminEmployeeSyncSettings.vue?vue&type=style&index=0&id=90dba8d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dba8d0",
  null
  
)

export default component.exports